<ics-desktop-app>
  <ics-app-logo
    app-logo
    scaleBy="height"
    [logo]="'assets/ics-tls-logo.svg'"
    collapsedLogo="assets/ics-logo-ball.png"
    [routerLink]="['/']" />

  <ics-sidenav-tools #tools sidenav-tools>
    <ics-authentication-menu [iconOnly]="tools.useCollapsedView()" />
  </ics-sidenav-tools>

  <ng-container toolbar-buttons>
    <app-history-handle />

    <ng-container *needsAuthorization="PrivilegeLevels.Admin">
      <app-un-lock-button routerLink="/admin/locker-panel" />

      <app-app-download-button />
    </ng-container>

    <ics-msg-tools />
  </ng-container>

  <ics-app-logo
    toolbar-logo
    logo="/assets/logos/pck-logo.png"
    [routerLink]="['/']" />

  <router-outlet />
</ics-desktop-app>
